import Run from '../components/flow/run';
import Activate from '../components/flow/activate';
import Properties from '../components/flow/Properties';
import Navigation from '../components/flow/navigation';
import SharedElements from '../components/flow/shared-elements';

export default [
    {
        name: 'Shared',
        tooltip: {
            title: 'Shared Elements',
            content: 'Manage shared elements that have been imported into this Flow'
        },
        icon: 'import',
        background: '#d95879',
        component: SharedElements
    },

    {
        name: 'Navigation',
        tooltip: {
            title: 'Navigation',
            content: 'Manage navigation bars for this Flow'
        },
        icon: 'object-align-top',
        background: '#baac93',
        component: Navigation
    },
    {
        name: 'Properties',
        tooltip: {
            title: 'Properties',
            content: 'Edit the Properties of this Flow i.e. Access Control, Social Feed, etc'
        },
        icon: 'pencil',
        style: 'warning',
        component: Properties
    },
    {
        name: 'Run',
        tooltip: {
            title: 'Run (Ctrl + R)',
            content: 'Build & Run this version of the Flow'
        },
        icon: 'play',
        style: 'primary',
        component: Run,
        shortcut: {
            control: true,
            shift: false,
            alt: false,
            code: 82
        }
    },
    {
        name: 'Publish',
        tooltip: {
            title: 'Publish',
            content: 'Make this version of the Flow the default version'
        },
        icon: 'cloud-upload',
        style: 'success',
        component: Activate
    }
]
